import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function EditUser({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Edit User'} email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

